<app-main *ngIf="!inIframe() && shouldLoadMainComponent"></app-main>
